import React from "react"
import { cn } from "../../utils/cn"

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
    /** Remove o padding interno padrão (útil para cards que contêm tabelas). */
    flush?: boolean
}

/** Superfície base do painel: fundo `surface`, borda tokenizada e cantos arredondados. */
const Card: React.FC<CardProps> = ({ flush, className, children, ...props }) => {
    return (
        <div
            className={cn(
                "bg-surface border border-border rounded-2xl shadow-card overflow-hidden",
                !flush && "p-5 sm:p-6",
                className
            )}
            {...props}
        >
            {children}
        </div>
    )
}

interface CardHeaderProps
    extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
    title: React.ReactNode
    description?: React.ReactNode
    actions?: React.ReactNode
}

/** Cabeçalho padrão de card: título + descrição à esquerda, ações à direita. */
export const CardHeader: React.FC<CardHeaderProps> = ({
    title,
    description,
    actions,
    className,
    ...props
}) => {
    return (
        <div
            className={cn(
                "flex flex-col gap-4 md:flex-row md:items-center md:justify-between",
                className
            )}
            {...props}
        >
            <div className="min-w-0">
                <h3 className="text-lg font-semibold text-text">{title}</h3>
                {description && (
                    <p className="mt-1 text-sm text-muted">{description}</p>
                )}
            </div>
            {actions && (
                <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
                    {actions}
                </div>
            )}
        </div>
    )
}

export default Card
